import { render, staticRenderFns } from "./RateChangeItem.vue?vue&type=template&id=f7f87024&scoped=true&"
import script from "./RateChangeItem.vue?vue&type=script&lang=js&"
export * from "./RateChangeItem.vue?vue&type=script&lang=js&"
import style0 from "./RateChangeItem.vue?vue&type=style&index=0&id=f7f87024&prod&scoped=true&lang=css&"
import style1 from "./RateChangeItem.vue?vue&type=style&index=1&id=f7f87024&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f87024",
  null
  
)

export default component.exports